<template>
    <b-card>
        <h4 class="crumbs" v-if="hasBreadCrumbs" >
            <span style="cursor: pointer;" @click="setLevel(item.id)" class="me-2" v-for="(item, idx) in getGroupCrumbs" :key="idx">
                <span v-if="item.isSop">
                    <i v-if="idx > 0" class="fas fa-chevron-right ms-2"></i>
                    <i class="fas fa-file-pdf ms-2"></i>
                    {{item.name}}
                </span>
                <span v-else>
                    <i v-if="idx > 0" class="fas fa-chevron-right ms-2 me-2"></i>
                    {{item.name}}
                </span>
            </span>
        </h4><!-- v-html="path" -->
        <h4 v-else>
            No Group Selected
        </h4>
    </b-card>
</template>

<script>
import _ from 'lodash'
import { sopAdminState,sopAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        file_details:{
            lvl_1:{
                name: 'Documents',
                type: 'folder',
            },
            lvl_2:{
                name: 'Saved Drafts',
                type: 'folder',
            },
            lvl_3:{
                name: 'Overview',
                type: 'document',
            }
        }
    }),
    computed:{
        ...sopAdminState,
        path(){
            let string = '';
            if(this.file_details.lvl_1 != null){
                string += `${this.returnIcon(this.file_details.lvl_1.type)} <span>${this.file_details.lvl_1.name}</span>`;

                if(this.file_details.lvl_2 != null){
                    string += `&nbsp;&nbsp;<i class='fas fa-chevron-right'/>&nbsp;&nbsp;`
                    string += `${this.returnIcon(this.file_details.lvl_2.type)} <span>${this.file_details.lvl_2.name}</span>`;

                    if(this.file_details.lvl_3 != null){
                        string += `&nbsp;&nbsp;<i class='fas fa-chevron-right'/>&nbsp;&nbsp;`
                        string += `${this.returnIcon(this.file_details.lvl_3.type)} <span>${this.file_details.lvl_3.name}</span>`;
                    }
                }
            }
            return string;
        },
        getGroupCrumbs(){
            let crumb_trail = [];
            let id = this.selected_sop_group;

            //* check if sop group has parents
            let sop = _.find(this.sop_groups, {id: id});
            if(sop != undefined){
                if(sop.parent_id == null){
                    crumb_trail.push(
                        {
                            'id': sop.id,
                            'name': sop.name,
                        }
                    );
                }
                else{
                    crumb_trail.push(
                        {
                            'id': sop.id,
                            'name': sop.name,
                        }
                    );
                    var found_all_parents = false;
                    let current = sop;
                    while(found_all_parents == false){
                        if(current.parent_id == null){
                            found_all_parents = true
                        }
                        else{
                            let item = _.find(this.sop_groups, {id: current.parent_id})
                            if(item != undefined){
                                crumb_trail.push(
                                    {
                                        'id': item.id,
                                        'name': item.name,
                                    }
                                );
                                current = item;
                            }
                            else{found_all_parents = true}
                        }
                    }
                }
            }


            _.reverse(crumb_trail);
            if(this.sop_data != null){
                crumb_trail.push(
                    {
                        'id': -1,
                        'name': this.sop_data.name,
                        'isSop': true
                    }
                );
            }
            return crumb_trail;
        },
        hasBreadCrumbs(){
            let valid = false;
            if(this.getGroupCrumbs.length > 0){
                valid = true;
            }
            return valid;
        }
    },
    methods:{
        ...sopAdminMethods,
        returnIcon(type){
            switch(type){
                case 'document':{
                    return `<i class="far fa-file-alt"/>`;
                }
                case 'folder':{
                    return `<i class="far fa-folder"/>`;
                }
            }
        },
        setLevel(id){
            if(id != -1){
                this.selectSopGroup(id);
            }
        }
    },
    mounted(){},
}
</script>

<style>
.crumbs span{
    font-family: var(--bs-font-sans-serif);
}
.crumbs span:hover{
    text-decoration: underline;
}
</style>